import { h,createApp } from "vue";
import { mountReplace } from "../../../utilities/mount-replace";

export async function initializeProductGallery(el: string, props: any) {
    const productGallery = (
        await import(
            /* webpackFetchPriority: "high" */
            "./ProductGallery.vue"
        )
    ).default;
    // const Vue = (
    //     await import(
    //         /* webpackFetchPriority: "high" */
    //         "vue"
    //     )
    // ).default;
    const comp = createApp({
        name: "product-gallery",
        render: function () {
            return h(productGallery, { ...props });
        },
    });
    mountReplace(comp, el);
}
